export default __webpack_public_path__ + "images/marker.7fda1fbbafd82fa7abce6b28165ee3cd.png";